addTypenameTransform